/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const enum SnapshotStatus {
  PROCESSING = 'Processing',
  AVAILABLE = 'Available',
  FAILED = 'Failed'
}

export type Snapshot = {
  counts?: SnapshotCounts;
  status: SnapshotStatus;
  created: string;
  updated: string;
  snapshot: string;
  assistant_id: string;
  assistant_references: AssistantReference[];
};

export interface SnapshotCounts {
  collections: number;
  actions: number;
  intents: number;
  entities: number;
  data_types: number;
  global_variables: number;
  dialog_nodes: number;
}

export interface AssistantReference {
  name: string;
  assistant_id: string;
  skill_reference: string;
}

export type SnapshotsSkill = {
  snapshots: Snapshot[];
  skillId: string;
};

export type SnapshotSkillId = {
  snapshotId: string;
  skillId: string;
};

export type SnapshotSkill = {
  snapshot: Snapshot;
  skillId: string;
};
